/**
 * Handle an optional redirect path.
 */
export const handleRequestRedirect = (redirectUrl?: string) => {
  if (!redirectUrl) {
    return;
  }

  const url = new URL(redirectUrl, process.env.BUN_PUBLIC_WEB_URL);

  if (url.origin !== process.env.BUN_PUBLIC_WEB_URL) {
    window.location.href = '/';
  } else {
    window.location.href = redirectUrl;
  }
};

export const handleSignInRedirect = (redirectUrl: string = '/') => {
  const url = new URL(redirectUrl, process.env.BUN_PUBLIC_WEB_URL);

  if (url.origin !== process.env.BUN_PUBLIC_WEB_URL) {
    window.location.href = '/';
  } else {
    window.location.href = redirectUrl;
  }
};
